import { Point } from 'google-map-react';

const MARKER_HEIGHT = 60;

export function customDistanceToMouse(point?: Point, mousePos?: Point) {
  // In reality point and mousePos could be undefined but googleMap types say they are not optional
  if (!point || !mousePos) {
    return 0;
  }

  const { x } = point;
  const y = point.y - MARKER_HEIGHT * 0.1;

  return Math.sqrt(
    (x - mousePos.x) * (x - mousePos.x) + (y - mousePos.y) * (y - mousePos.y),
  );
}
